import { render, staticRenderFns } from "./withdrawRequest.vue?vue&type=template&id=5a0f7020&"
import script from "./withdrawRequest.vue?vue&type=script&lang=js&"
export * from "./withdrawRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports